import { Box, Button, TextField } from '@mui/material'
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { MRT_Localization_FR } from 'material-react-table/locales/fr';
import React, { useMemo } from 'react'
import FileUploadIcon from '@mui/icons-material/FileUpload';
import PageHeader from '../../../components/common/PageHeader';

function Quotes() {

const [quotes, setQuotes] = React.useState([]);


        const columns = useMemo(
          () => [
            {
              id: 'quotes', //id used to define `group` column
                columns: [
                {
                  accessorFn: (row) => row.name,
                  id: 'name',
                  header: 'Nom',
                  Cell: ({ renderedCellValue }) => (
                  <Box>{renderedCellValue}</Box>
                  ),
                },
              ],
            },
          ],
          [],
        );
        

      const table = useMaterialReactTable({
    localization: MRT_Localization_FR,
    enableGlobalFilter: true,
    enableColumnFilters: true,

          columns,
          data: quotes ? quotes : null, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
          enableColumnFilterModes: true,
          enableColumnOrdering: true,
          enableGrouping: true,
          enableColumnPinning: true,
          enableFacetedValues: true,
          initialState: {
            density:"compact",
            // showColumnFilters: true,
            // showGlobalFilter: true,
            columnPinning: {
              left: ['mrt-row-expand', 'mrt-row-select'],
              right: ['mrt-row-actions'],
            },
            pagination: {
              pageSize: 50,
    
            }
          },
          paginationDisplayMode: 'pages',
          positionToolbarAlertBanner: 'bottom',
          muiSearchTextFieldProps: {
            size: 'small',
            variant: 'outlined',
          },
          muiPaginationProps: {
            color: 'secondary',
            rowsPerPageOptions: [10, 20, 30],
            shape: 'rounded',
            variant: 'outlined',
          },
        });



return (
    <Box>
        <PageHeader section="Administratif" title="Devis" sx={{ my: 2 }} />
        <Box display={'flex'} alignContent={'center'} justifyContent={'space-between'} sx={{ mb: 2 }}>
            <Button variant="contained" startIcon={<FileUploadIcon />} size='small' color="primary">
                Importer un devis
            </Button>
        </Box>
        <Box>
            <MaterialReactTable table={table}  />
        </Box>
    </Box>
)
}

export default Quotes
